export default __webpack_public_path__ + "static/awarepath_small-image_3-859fec632328bda5718f9cf52470631e.png";